<template>
    <div class="wrapper">
        <div class="pane">
            <div class="title"><Title :text="title"></Title></div>
            <div class="content">
                <slot></slot>
            </div>
        </div>
    </div>
</template>
<script>
import { Title } from '@/components';

export default {
    name: 'DetailWrapper',
    components: { Title },
    props: {
        title: {
            type: String
        }
    }
};
</script>
<style lang="less" scoped>
.wrapper {
    .pane {
        margin-bottom: 48px;

        .title {
            position: relative;
            margin-bottom: 28px;
        }
    }
}
</style>
